import { UseCaseResultErrorCode } from "@interfaces/heap-api";

export const HEAP_PAYMENT_ERRORS = {
    /**
     * Payment failed due to an issue with the payment provider.
     */
    PAYMENT_FAILED: "PAYMENT_FAILED",
    /**
     * Cart validation failed
     */
    CartValidationFailure: UseCaseResultErrorCode.CartValidationFailure,
    /**
     * General validation
     */
    Validation: UseCaseResultErrorCode.Validation,
    /**
     * ShippingAddress == null
     * BillingAddress == null
     */
    AddressObjectMissing: UseCaseResultErrorCode.AddressObjectMissing,
    /**
     * Missing PostalCode
     */
    PostCodeMissing: UseCaseResultErrorCode.PostCodeMissing,
    /**
     * Missing StreetName
     */
    StreetNameMissing: UseCaseResultErrorCode.StreetNameMissing,
    /**
     * Any address invalid
     */
    AddressInvalid: UseCaseResultErrorCode.AddressInvalid,
    /**
     * Missing (FirstName AND LastName) OR CompanyName
     */
    NameAndLastNameOrCompanyNameMissing: UseCaseResultErrorCode.NameAndLastNameOrCompanyNameMissing,
} as const;

export type HeapPaymentErrorType = keyof typeof HEAP_PAYMENT_ERRORS;

export const CHECKOUT_ERRORS = {
    MissingEmail: "MissingEmail",
    EmailInvalid: "EmailInvalid",
    MissingPhone: "MissingPhone",
    PhoneInvalid: "PhoneInvalid",
    ItemsOutOfStock: "ItemsOutOfStock",
    CartInvalid: "CartInvalid",
    CCStoreAddressInvalid: "CCStoreAddressInvalid",
    DeliveryMethodInvalid: "DeliveryMethodInvalid",
    /** Express is on the cart, but the cart holds a product Express may not carry. */
    ExpressUnavailableForProducts: "ExpressUnavailableForProducts",
} as const;

export type CheckoutErrorType = keyof typeof CHECKOUT_ERRORS;
